<template>
  <div class="flex">
    <div class="margin-right-40">
      <!-- 电池仓 -->
      <!-- 电池信息--表格 -->
      <LeftSiteInformation :userList="siteInfoList" :bigtitle="siteInfoTitle"/>
      <!-- 累计里程 -->
      <AccumulatedMileage :warrantyMileage="warrantyMileage"/>
      <!-- 电池健康状态 -->
      <BatteryHealthStatus/>
    </div>
    <div>
      <!-- 单个站点--考核指标 -->
      <taskIndicators class="taskIndicators"/>  
      <div class="flex justify-between">
        <!-- 充电参数实时监测 -->
        <ChargeTrendBar/>
      </div>
      <!-- 电池包信息 -->
      <BigTitle :bigtitle="performanceTitle"></BigTitle>
      <div class="flex">
        <Table :title="'电池包信息'" :config="config1" :is760="true"></Table>
        <!-- <div class="margin-left-15">
          <Table :title="'电池预警'" :config="config2" :is120="true"></Table>
          <Table :title="'维修记录'" :config="config3" :is100="true"></Table>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import BigTitle from '../bigTitle';
//电池信息
import LeftSiteInformation from "@/views/singleSite/leftSiteInformation";
// 累计里程
import AccumulatedMileage from "@/components/echart/batteryBoxCharts/accumulatedMileage.vue";
// 电池健康状态
import BatteryHealthStatus from "@/components/echart/batteryBoxCharts/batteryHealthStatus.vue";
//成本分析
import taskIndicators from "@/views/batteryBox/evaluationIndex";
//成本分析
import ChargeTrendBar from "@/components/echart/batteryBoxCharts/chargeTrendBar.vue";
//表格
import Table from "@/components/common/table";



import { dataInterface } from '@/api/dataInterfaceApi';

export default {
  data () {
    return {
      options: {},
      // 站点信息
      //标题
      siteInfoTitle:{
        CHN:'电池指标',
        ENG:'Battery index'
      },
      performanceTitle:{
        CHN:'电池包信息',
        ENG:'Operational indicators'
      },
      config1: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 6, //表格行数
        header:["电池单体编码", "温度探测点编号", "温度(℃)", "电压(V)"],
        data: [],
      },
      config2: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 3, //表格行数
        header: ["电池包编码", "告警时间","告警类型"],
        data: [],
      },
      //暂时前端写死
      config3: {
        headerBGC: "rgba(53, 149, 147, 0.2)",
        headerHeight: 42,
        carousel: "single",
        hoverPause: true,
        oddRowBGC: "rgba(53, 149, 147, 0)",
        evenRowBGC: "rgba(53, 149, 147, 0)",
        rowNum: 2, //表格行数
        header: ["维修时间", "维修内容", "更换设备","返回时间"],
        data: [],
      },
      //展示数据
      siteInfoList:[{
        key:'电池编码',
        value:""
      },{
        key:'生产商',
        value:""
      },{
        key:'电池材料类型',
        value:""
      },{
        key:'适用车型',
        value:''
      },{
        key:'硬件版本号',
        value:""
      },{
        key:'软件版本号',
        value:""
      },{
        key:'交付日期',
        value:""
      },{
        key:'质保年限',
        value:""
      },{
        key:'额定电压',
        value:""
      },{
        key:'额定容量',
        value:""
      },{
        key:'质保里程',
        value:""
      },{
        key:'资产属性',
        value:""
      }],

      //车辆指标
      //标题
      carIndicatorsTitle:{
        CHN:'车辆指标',
        ENG:'Car indicators'
      },
      //展示数据
      carIndicatorsList:[{
        counts:'',
        text:"换电车辆数"
      },{
        counts:'',
        text:"单车日均换电次数"
      },{
        counts:'',
        text:"本月新增车辆数"
      },{
        counts:'',
        text:"单车日均换电里程"
      }],
      userList:[{},{},{},{}],
      //用户指标
      selectUserTarget:{},
      batteryAmount:'',
      warrantyMileage:'',
    };
  },
  components: {
    BigTitle,
    LeftSiteInformation,
    AccumulatedMileage,
    BatteryHealthStatus,
    ChargeTrendBar,
    taskIndicators,
    Table,
  },
  props: {
  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    // 刷新接口需要每个子组件封装一个getData();
    getData(data){
      this.selectBatteryInfo(data)
      // 电池预警
      this.batterAlarmInfo(data)
      //电池包信息
      this.getBatteryPackageInfo(data)
      // 维修记录
      this.selectMaintainRecord(data);
    },
    //维修记录
    selectMaintainRecord(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-dianchixiang-weixiujilu',
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          let newList = [];
          [...res].map(item => {
						let arrlist = [
              item.weixiukssj,
              item.weixiunr,
              item.lsthdianchi,
              item.weixiujssj,
            ];
						newList.push(arrlist)
          });
          console.log('newList',newList)
					_this.config3 = {
              headerBGC: "rgba(53, 149, 147, 0.2)",
              headerHeight: 42,
              carousel: "single",
              hoverPause: true,
              oddRowBGC: "rgba(53, 149, 147, 0)",
              evenRowBGC: "rgba(53, 149, 147, 0)",
              rowNum: 2, //表格行数
              header:["维修时间", "维修内容", "更换设备","返回时间"],
              data:newList
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectBatteryInfo(data={}){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-dianchixiang-dianchizhibiao',
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          res = res[0];
          console.log("电池指标",res)
          // 电池健康状态值
          _this.warrantyMileage = res.warrantyMileage;
          this.siteInfoList = [{
        key:'电池编码',
        value:res.batteryNumber
      },{
        key:'生产商',
        value:res.production
      },{
        key:'电池材料类型',
        value:res.battery_business_type
      },{
        key:'适用车型',
        value:''
      },{
        key:'硬件版本号',
        value:res.hardwareVersion
      },{
        key:'软件版本号',
        value:res.softwareVersion
      },{
        key:'交付日期',
        value:res.deliveryDate
      },{
        key:'质保年限(年)',
        value:res.warrantyPeriod
      },{
        key:'额定电压(V)',
        value:res.ratedVoltage
      },{
        key:'额定容量(kWh)',
        value:res.ratedTotalEnergy
      },{
        key:'质保里程(km)',
        value:res.warrantyMileage
      },{
        key:'资产属性',
        value:""
      }]
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //电池包信息
    getBatteryPackageInfo(data){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-dianchixiang-dianchidantixinxi',
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          res = res[0];
          let newList = [];
          console.log("电池单体信息",res);
          let st = res.st.split('|');
          let stList = st.slice(2,st.length);
          let sv = res.sv.split('|');
          let scList = sv.slice(2,st.length);

          [...stList].map((item,index) => {
						let arrlist = [
              index+1,
              index+1,
              item,
              parseFloat(scList[index]).toFixed(2)
            ];
						newList.push(arrlist)
          });
          console.log('newList',newList)
					_this.config1 = {
              headerBGC: "rgba(53, 149, 147, 0.2)",
              headerHeight: 42,
              carousel: "single",
              hoverPause: true,
              oddRowBGC: "rgba(53, 149, 147, 0)",
              evenRowBGC: "rgba(53, 149, 147, 0)",
              align:['','center','center','center'],
              rowNum: 6, //表格行数
              header: ["电池单体编码", "温度探测点序号", "温度(℃)", "电压(V)"],
              data:newList
					};
        })
        .catch((err) => {
          console.log(err);
        });
    },
    batterAlarmInfo(data){
      let _this = this;
      dataInterface
        .dataFaceApi({
          'enCode':'TiDB-dianchixiang-dianchiyujing',//TiDB-电池箱-电池预警
          '@battery_id':data.batteryId
        })
        .then((res) => {
          if(!res) return;
          let newList = [];
          [...res].map(item => {
						let arrlist = [
              item.batteryId,
              item.timeOccurrence,
              item.alarmLevel,
            ];
						newList.push(arrlist)
          });
          console.log('newList',newList)
					_this.config2 = {
              headerBGC: "rgba(53, 149, 147, 0.2)",
              headerHeight: 42,
              carousel: "single",
              hoverPause: true,
              oddRowBGC: "rgba(53, 149, 147, 0)",
              evenRowBGC: "rgba(53, 149, 147, 0)",
              rowNum: 3, //表格行数
              header: ["电池包编码", "告警时间","告警类型"],
							data: newList,
					};
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
.taskIndicators{
  width:1550px;
}

</style>